<img src="/assets/images/icon_image.svg" (click)="openFileManager()" />

<input #imgInput id="product-image" type="file" (change)="fileSelected()" />
